// «Нашли баг?» — canalul prin care afli ce nu merge.
//
// Din videoclipul lor: butonul e peste tot, iar sesizarea ajunge într-o listă pe care
// proprietarul o citește. Două decizii proprii:
//   • se primesc și de la vizitatori — cine dă de un defect înainte să-și facă un cont
//     e exact cel de la care vrei să afli;
//   • pagina și browserul se atașează automat. Fără ele, jumătate din sesizări sunt
//     „nu merge" și nicio pistă de urmat.

import { el, clear } from '../core/util.js';
import { icon } from './icons.js';
import { modal, toast } from './components.js';

const KINDS = [
  { id: 'bug', label: 'Нашли баг' },
  { id: 'idea', label: 'Улучшение платформы' },
  { id: 'abuse', label: 'Жалоба на пользователя' },
  { id: 'other', label: 'Другое' },
];

function contextInfo() {
  return [
    location.pathname + location.search,
    `${window.innerWidth}×${window.innerHeight}`,
    navigator.userAgent.slice(0, 160),
  ].join(' | ');
}

export function openSupport({ kind = 'bug' } = {}) {
  let ales = kind;

  const kindEl = el('div', { class: 'idea-setups' }, KINDS.map((k) => el('button', {
    class: `idea-setup-btn${k.id === ales ? ' active' : ''}`,
    text: k.label,
    onclick: (e) => {
      ales = k.id;
      for (const b of e.target.parentElement.children) b.classList.remove('active');
      e.target.classList.add('active');
    },
  })));

  const subjectEl = el('input', { class: 'auth-input', placeholder: 'Кратко: что произошло' });
  const textEl = el('textarea', {
    class: 'idea-form-text', rows: 4,
    placeholder: 'Что делали, что ожидали увидеть и что увидели вместо этого.',
  });

  let shot = '';
  const previewEl = el('div', { class: 'rep-shot' });
  const fileEl = el('input', {
    type: 'file', accept: 'image/*', style: { display: 'none' },
    onchange: (e) => {
      const f = e.target.files[0];
      if (!f) return;
      const r = new FileReader();
      r.onload = () => {
        const img = new Image();
        img.onload = () => {
          const scale = Math.min(1, 1280 / img.width);
          const cv = document.createElement('canvas');
          cv.width = Math.round(img.width * scale);
          cv.height = Math.round(img.height * scale);
          cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
          shot = cv.toDataURL('image/jpeg', 0.72);
          clear(previewEl).append(el('img', { class: 'share-preview', src: shot, alt: '' }));
        };
        img.src = r.result;
      };
      r.readAsDataURL(f);
    },
  });

  const errEl = el('div', { class: 'auth-error' });

  modal({
    title: 'Обращение в поддержку',
    width: 500,
    body: el('div', { class: 'idea-form' }, [
      kindEl,
      el('label', { class: 'auth-field' }, [icon('pencil', 12), subjectEl]),
      textEl,
      el('label', { class: 'btn rep-attach' }, [icon('camera', 12), el('span', { text: 'Скриншот' }), fileEl]),
      previewEl,
      el('p', { class: 'guest-note' }, [
        icon('info', 11),
        el('span', { text: 'К обращению приложим адрес страницы и данные браузера — так проблему найти быстрее.' }),
      ]),
      errEl,
    ]),
    actions: [
      { label: 'Отмена', onClick: (c) => c() },
      {
        label: 'Отправить', primary: true,
        onClick: async (c) => {
          errEl.textContent = '';
          try {
            const resp = await fetch('/api/support/tickets', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                kind: ales, subject: subjectEl.value, text: textEl.value,
                shot, context: contextInfo(),
              }),
            });
            const data = await resp.json();
            if (!resp.ok) throw new Error(data.detail);
            c();
            toast('Спасибо — обращение принято', 'success');
          } catch (err) {
            errEl.textContent = err.message || 'Не удалось отправить';
          }
        },
      },
    ],
  });
  setTimeout(() => subjectEl.focus(), 30);
}
